module.exports = __webpack_public_path__ + "d71608f07bdab1df6642ffea1f265850.png";